export default __webpack_public_path__ + "static/media/img-education.43cebc33.svg";